<div class="modal" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
    <div class="modal-dialog modal-xl">
        <div class="modal-content ">
            <div class="modal-header">
                <div class="col-md-12 col-12 d-flex justify-content-between">
                    <strong>{{isAddChild?'Add Child':'Child Details'}}</strong>
                    <a style="cursor: pointer;" (click)="Cancel()"> <i class="fa fa-remove"></i></a>
                </div>
            </div>
            <div class="row modal-body">
                <div class="el-work-wrapper el-object-wrapper">
                    <div class="container">

                        <!--  CHILD LIST VIEW -->
                        <div class="row" *ngIf="isAddChild==false">
                            <div class="col-lg-4 col-md-6" *ngFor="let child of ChildList" style="margin-top: 20px;">
                                <div class="el-work-box el-work-box-1">

                                    <div class="el-work-box-inner">

                                        <div class="d-flex justify-content-end">
                                            <span class="bg-success text-light"
                                                style="border-radius: 10px; padding: 5px 10px;"
                                                *ngIf="child.ActiveStudent ==1">Active</span>
                                        </div>

                                        <div class="el-work-img"
                                            [ngStyle]="{'border-color':child.ActiveStudent==1? 'green':'' }">
                                            <img [src]="child.Photo" alt="work icon">
                                        </div>

                                        <div class="el-work-content">
                                            <div class="text-start">
                                                <ul>
                                                    <li><i class="fa fa-user"></i>Child Name:
                                                        <strong>{{child.childName}}</strong>
                                                    </li>
                                                    <li *ngIf="child.ClassId <= '12'"><i
                                                            class="fa fa-graduation-cap"></i>Class
                                                        <strong>{{child.ClassId}}</strong>
                                                    </li>
                                                    <li *ngIf="child.ClassId > '12'"><i
                                                            class="fa fa-graduation-cap"></i>Class
                                                        <strong>{{child.className}}</strong>
                                                    </li>
                                                    <li></li>
                                                </ul>
                                            </div>

                                            <div class="col-lg-12 d-flex justify-content-center">
                                                <a class="el-btn my-2" (click)="Edit(child.StudentId)"> Edit</a>
                                                &nbsp;&nbsp;
                                                <a class="el-btn my-2" *ngIf="child.ActiveStudent==null"
                                                    (click)="Switch(child.StudentId)">Switch </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  ADD NEW CHILD CARD -->
                            <div *ngIf="ChildList.length<5"
                                [ngClass]="{'col-lg-12': ChildList.length==0, 'col-md-12': ChildList.length==0,'col-lg-4': ChildList.length>0, 'col-md-6': ChildList.length>0}"
                                (click)="isAddChild = !isAddChild;isEdit = false" style="margin-top: 20px;">
                                <div class="el-work-box el-work-box-2">
                                    <div class="el-work-box-inner">
                                        <div class="el-work-img">
                                            <i class="fa fa-plus fa-3x"></i>
                                        </div>
                                        <div class="el-work-content">
                                            <div class="col-lg-12 ">
                                                <h4>Add Child</h4>
                                                <a class="el-btn">Add</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!--  ADD/EDIT CHILD FORM -->
                        <div class="row" *ngIf="isAddChild">
                            <div class="el-contact-page-info">
                                <form [formGroup]="object" (ngSubmit)="saveChildRecord()">
                                    <div class="row d-flex justify-content-evenly">

                                        <!--  PHOTO SECTION -->
                                        <div class="col-md-12">
                                            <div class="el-input-field text-center" [hidden]="capturedImage!=null">

                                                <!--  CAMERA VIEW -->
                                                <div [hidden]="isShowCamera==false">
                                                    <div class="d-flex justify-content-center">
                                                        <div id="camera-container">
                                                            <video id="CameraId" #CameraId autoplay style="width:320px;"
                                                                class="">
                                                            </video>
                                                            <div id="frame" #frame width="150" height="180" class="">
                                                            </div>
                                                            <canvas #canvas width="150" height="180"
                                                                style="border: 1px solid red; display: none;"></canvas>
                                                        </div>
                                                    </div>

                                                    <div class="row mb-3" style="margin-top: 10px;">
                                                        <div class="d-flex justify-content-center">
                                                            <button type="button" class="el-btn py-4"
                                                                (click)="captureImage()">Capture Photo</button> &nbsp;

                                                            <span *ngIf="isManualUplode" class="mt-3 me-2">
                                                                OR
                                                            </span>
                                                            <button type="button" class="el-btn py-4"
                                                                (click)="ngOnDestroy()" *ngIf="isManualUplode"><span>
                                                                    Upload Photo</span>
                                                            </button>

                                                        </div>

                                                        <p class="cursor typewriter-animation mt-3"
                                                            style="color: rgb(0, 0, 0);margin-top: 20px;">Photo
                                                            verification may take 30 seconds or more.</p>
                                                    </div>
                                                    <p [innerHTML]="msg" style="text-align: left;color: red;"></p>
                                                </div>

                                                <!--  PREVIEW IMAGE (when photo exists but camera closed) -->
                                                <img *ngIf="object.get('photo')?.value && !isShowCamera"
                                                    [src]="object.get('photo')?.value" width="150" height="180"
                                                    alt="Preview" class="round-cam">

                                                <!--  DEFAULT PLACEHOLDER IMAGE -->
                                                <img *ngIf="!isShowCamera && isEdit ==false && !object.get('photo')?.value"
                                                    src="/assets/images/all-instructor/StudentImage.png" width="150"
                                                    height="180" alt="image" class="img-fluid">
                                                <br>

                                                <!--  BUTTONS: Take Live Photo OR Upload Photo -->
                                                <div class="d-flex justify-content-center align-items-center gap-2"
                                                    *ngIf="!isShowCamera" style="margin-top: 10px; flex-wrap: wrap;">
                                                    <button type="button" class="el-btn" (click)="openCamera()"
                                                        *ngIf="!isManualUplode">
                                                        <i class="fa fa-camera"></i> Take Live Photo
                                                    </button>


                                                    <!--  Hidden file input -->
                                                    <input type="file" #fileInput accept="image/*"
                                                        (change)="onFileSelected($event)" style="display: none;">
                                                    <button type="button" class="el-btn" (click)="triggerFileInput()"
                                                        *ngIf="isManualUplode">
                                                        <i class="fa fa-upload"></i> Upload Photo
                                                    </button>
                                                </div>

                                                <small class="text-danger"
                                                    *ngIf="object.get('photo')?.touched && object.get('photo')?.invalid">
                                                    Photo is required
                                                </small>
                                            </div>

                                            <!--  CAPTURED IMAGE PREVIEW -->
                                            <div *ngIf="capturedImage!=null" class="text-center">
                                                <img height="180px" [src]="capturedImage" alt="Captured"
                                                    class="thumbnail" /><br>
                                                <div class="d-flex justify-content-center gap-2"
                                                    style="margin-top: 10px;">
                                                    <button type="button" class="el-btn py-4" (click)="openCamera()"
                                                        *ngIf="usingFile==false">
                                                        <i class="fa fa-camera"></i> Retake Live Photo
                                                    </button>
                                                    <button type="button" class="el-btn py-4"
                                                        (click)="triggerFileInput()"
                                                        *ngIf="isManualUplode && usingFile ==true"> <i
                                                            class="fa fa-upload"></i>
                                                        Change Photo</button>
                                                </div>
                                                <br>
                                            </div>
                                        </div>

                                        <!-- FORM FIELDS -->
                                        <div class="col-md-12">
                                            <!-- Child Name -->
                                            <div class="el-input-field">
                                                <input type="text" placeholder="Child Name" formControlName="childName">
                                                <small class="text-danger"
                                                    *ngIf="object.get('childName')?.touched && object.get('childName')?.hasError('required')">
                                                    Name is required
                                                </small>
                                                <small class="text-danger"
                                                    *ngIf="object.get('childName')?.touched && object.get('childName')?.hasError('minlength')">
                                                    Name must be at least 2 characters
                                                </small>
                                            </div>

                                            <!-- Class Selection -->
                                            <div class="el-input-field">
                                                <select class="form-control ng-pristine ng-valid ng-touched"
                                                    style="height: 50px; background-color: transparent; border: 1px solid #e04787;"
                                                    formControlName="classId">
                                                    <option [ngValue]="null" disabled selected>--Select Class--</option>
                                                    <option [ngValue]="1">Class 1</option>
                                                    <option [ngValue]="2">Class 2</option>
                                                    <option [ngValue]="3">Class 3</option>
                                                    <option [ngValue]="4">Class 4</option>
                                                    <option [ngValue]="5">Class 5</option>
                                                    <option [ngValue]="6">Class 6</option>
                                                    <option [ngValue]="7">Class 7</option>
                                                    <option [ngValue]="8">Class 8</option>
                                                    <option [ngValue]="9">Class 9</option>
                                                    <option [ngValue]="10">Class 10</option>
                                                    <option [ngValue]="11">Class 11</option>
                                                    <option [ngValue]="12">Class 12</option>
                                                    <option [ngValue]="13">LKG</option>
                                                    <option [ngValue]="14">UKG</option>
                                                    <option [ngValue]="15">Nursery</option>
                                                </select>
                                                <small class="text-danger"
                                                    *ngIf="object.get('classId')?.touched && object.get('classId')?.invalid">
                                                    Class is required
                                                </small>
                                            </div>

                                            <!-- Action Buttons -->
                                            <div class="col-lg-12 d-flex justify-content-between">
                                                <button type="button"
                                                    (click)="isAddChild=false ; object.reset();capturedImage = null;"
                                                    class="el-btn py-4">Back</button>

                                                <button type="submit" class="el-btn py-4">
                                                    {{ object.get('id')?.value > 0 ? 'Update' : 'Add' }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>